<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-5" d="m57.73,67.14h-20.3c-.9,0-1.64-.73-1.64-1.64s.73-1.64,1.64-1.64h20.3c.9,0,1.64.73,1.64,1.64s-.73,1.64-1.64,1.64Z"/>
  <circle class="cls-5" cx="30.6" cy="65.51" r="1.67"/>
  <path class="cls-5" d="m57.73,31.82h-20.3c-.9,0-1.64-.73-1.64-1.64s.73-1.64,1.64-1.64h20.3c.9,0,1.64.73,1.64,1.64s-.73,1.64-1.64,1.64Z"/>
  <path class="cls-5" d="m57.73,43.64h-20.3c-.9,0-1.64-.73-1.64-1.64s.73-1.64,1.64-1.64h20.3c.9,0,1.64.73,1.64,1.64s-.73,1.64-1.64,1.64Z"/>
  <circle class="cls-5" cx="30.6" cy="30.19" r="1.67"/>
  <circle class="cls-5" cx="30.6" cy="42" r="1.67"/>
  <path class="cls-5" d="m57.73,55.45h-20.3c-.9,0-1.64-.73-1.64-1.64s.73-1.64,1.64-1.64h20.3c.9,0,1.64.73,1.64,1.64s-.73,1.64-1.64,1.64Z"/>
  <circle class="cls-5" cx="30.6" cy="53.81" r="1.67"/>
  <path class="cls-4" d="m66.83,79.49H21.71c-1.05,0-1.91-.85-1.91-1.91V14.78c0-1.05.85-1.91,1.91-1.91h45.11c1.05,0,1.91.85,1.91,1.91v62.8c0,1.05-.85,1.91-1.91,1.91Zm-43.2-3.82h41.3V16.68H23.62v58.99Z"/>
  <g>
    <rect class="cls-1" x="33.88" y="11.27" width="20.77" height="8.61"/>
    <path class="cls-3" d="m54.66,21.78h-20.77c-1.05,0-1.91-.85-1.91-1.91v-8.6c0-1.05.85-1.91,1.91-1.91h20.77c1.05,0,1.91.85,1.91,1.91v8.6c0,1.05-.85,1.91-1.91,1.91Zm-18.87-3.82h16.96v-4.79h-16.96v4.79Z"/>
  </g>
  <g>
    <circle class="cls-1" cx="59.47" cy="71.13" r="13.39"/>
    <path class="cls-3" d="m59.47,85.88c-8.14,0-14.75-6.62-14.75-14.76s6.62-14.76,14.75-14.76,14.76,6.62,14.76,14.76-6.62,14.76-14.76,14.76Zm0-26.79c-6.63,0-12.03,5.4-12.03,12.03s5.4,12.03,12.03,12.03,12.03-5.4,12.03-12.03-5.4-12.03-12.03-12.03Z"/>
  </g>
  <g>
    <rect class="cls-3" x="59.32" y="65" width=".29" height="13.95"/>
    <path class="cls-3" d="m64.79,79.24h-10.66c-1.07,0-1.94-.87-1.94-1.94v-10.66c0-1.07.87-1.94,1.94-1.94h10.66c1.07,0,1.94.87,1.94,1.94v10.66c0,1.07-.87,1.94-1.94,1.94Zm-10.66-13.95c-.75,0-1.35.61-1.35,1.35v10.66c0,.75.61,1.35,1.35,1.35h10.66c.75,0,1.35-.61,1.35-1.35v-10.66c0-.75-.61-1.35-1.35-1.35h-10.66Z"/>
    <g>
      <g>
        <path class="cls-2" d="m63.47,69.57c-.06,0-.12.01-.16.05-.47.35-1.13.57-1.85.57s-1.38-.22-1.86-.58c-.04-.03-.09-.04-.14-.04v-6.36h3.63l.38,6.36Z"/>
        <path class="cls-6" d="m61.47,70.29c-.72,0-1.41-.21-1.92-.6-.02-.01-.05-.02-.08-.02h-.1v-6.55h3.82l.39,6.56h-.11s-.08,0-.1.02c-.51.38-1.19.59-1.91.59Zm-1.9-.81s.07.03.1.05c.48.36,1.12.56,1.8.56s1.31-.2,1.79-.55c.03-.03.07-.04.12-.05l-.37-6.18h-3.44v6.17Z"/>
      </g>
      <g>
        <path class="cls-2" d="m55.83,63.21l-.38,6.36s-.1.02-.14.05c-.47.35-1.13.57-1.85.57-.06,0-.12,0-.18,0-1.62-.08-2.69-1.31-2.24-2.49l.2-.52,1.4-3.66c.07-.19.3-.32.56-.32h2.62Z"/>
        <path class="cls-6" d="m53.47,70.29c-.06,0-.12,0-.19,0-.92-.05-1.72-.46-2.14-1.11-.31-.47-.37-1.01-.18-1.51l1.6-4.17c.09-.23.35-.38.65-.38h2.72l-.39,6.55h-.09s-.06.01-.08.03c-.51.38-1.19.59-1.9.59Zm-.25-6.98c-.22,0-.42.11-.47.26l-1.6,4.17c-.17.44-.11.92.16,1.34.39.59,1.13.98,1.99,1.02.06,0,.12,0,.17,0,.68,0,1.31-.2,1.79-.55.03-.02.06-.04.1-.05l.37-6.18h-2.51Z"/>
      </g>
      <path class="cls-4" d="m59.47,63.21v6.36c-.05,0-.11.01-.14.04-.47.36-1.13.58-1.86.58s-1.37-.22-1.84-.57c-.05-.04-.11-.05-.17-.05l.38-6.36h3.64Z"/>
      <path class="cls-4" d="m65.65,70.19c-.06,0-.12,0-.18,0-.72,0-1.37-.22-1.85-.57-.04-.03-.09-.04-.15-.05l-.38-6.36h2.64c.25,0,.47.13.54.31l1.4,3.67.2.52c.45,1.17-.62,2.4-2.24,2.48Z"/>
    </g>
    <path class="cls-3" d="m60.81,74.02c-.13,0-.24-.11-.24-.24v-1.12c0-.13.11-.24.24-.24s.24.11.24.24v1.12c0,.13-.11.24-.24.24Z"/>
    <path class="cls-3" d="m58.24,74.02c-.13,0-.24-.11-.24-.24v-1.12c0-.13.11-.24.24-.24s.24.11.24.24v1.12c0,.13-.11.24-.24.24Z"/>
    <path class="cls-3" d="m65.47,70.39c-.74,0-1.44-.22-1.96-.61-.02-.01-.06-.01-.08,0-.53.4-1.22.61-1.96.61s-1.45-.22-1.97-.62c-.01,0-.04,0-.05,0-.53.4-1.23.62-1.97.62s-1.44-.22-1.96-.61c-.02-.01-.06-.01-.07,0-.53.39-1.22.61-1.96.61-.06,0-.13,0-.19,0-.95-.05-1.78-.48-2.22-1.15-.32-.5-.39-1.06-.19-1.6l1.6-4.17c.1-.27.4-.44.75-.44h12.52c.34,0,.63.17.73.43l1.6,4.18c.2.53.14,1.1-.19,1.6-.44.67-1.27,1.1-2.22,1.15-.06,0-.13,0-.19,0Zm-2-1.01c.1,0,.19.03.27.09.46.35,1.07.54,1.73.54.06,0,.11,0,.17,0,.83-.04,1.54-.41,1.91-.98.25-.39.31-.83.15-1.24l-1.6-4.18c-.03-.09-.17-.18-.36-.18h-12.52c-.18,0-.34.08-.38.19l-1.6,4.17c-.16.41-.11.86.15,1.25.37.57,1.09.93,1.92.98.06,0,.11,0,.17,0,.65,0,1.27-.19,1.73-.53.15-.12.39-.11.54,0,.46.34,1.07.53,1.73.53s1.28-.19,1.74-.54c.15-.11.37-.11.52,0,.46.35,1.08.54,1.74.54s1.27-.19,1.73-.54c.08-.06.17-.09.27-.09Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "ROMRetailerListIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #b3decd;
  }
  .cls-3 {
    fill: #115c72;
  }
  .cls-4 {
    fill: #59c5c7;
  }
  .cls-5 {
    fill: #cfeae0;
  }
  .cls-6 {
    fill: #135d73;
  }
</style>